const fireDTMevent = (eventNumber) => {
    /* eslint-disable no-undef */
    /* DTM Global */
    if (typeof s === "undefined") return;
    s.clearVars();
    s.addEvent(`event${eventNumber}`);
    s.tl();
    s.clearVars();
    /* eslint-enable no-undef */
};

/**
 * Fires DTM event. Should be called when a form is viewed (or would be viewed
 * for the hidden forms)
 * @param {string} [vertical=business]
 */
export const triggerRequestForm = (vertical = "business") => {
    const requestEventNumberMap = {
        business: "52",
        k12: "53",
        publicsector: "59",
        highered: "60"
    };
    const eventNumber = requestEventNumberMap[vertical] || "52";
    fireDTMevent(eventNumber);
};

/**
 * Fires DTM event. Should be called when a form is submitted.
 * @param {string} [vertical=business]
 */
export const triggerSubmit = (vertical = "business") => {
    const submitEventNumberMap = {
        business: "42",
        k12: "43",
        publicsector: "49",
        highered: "50"
    };
    const eventNumber = submitEventNumberMap[vertical] || "42";
    fireDTMevent(eventNumber);
};
